import { toast as sonnerToast } from "sonner";

/**
 * Simplified toast hook using Sonner
 * No complex state management needed - Sonner handles everything
 */
export function useToast() {
  return {
    toast: ({
      title,
      description,
      variant = "default",
    }: {
      title?: string;
      description?: string;
      variant?: "default" | "destructive";
    }) => {
      // If only description provided, show it as the main message (no title)
      if (!title && description) {
        if (variant === "destructive") {
          sonnerToast.error(description);
        } else {
          sonnerToast.success(description);
        }
        return;
      }

      // If title provided, show both title and description
      if (variant === "destructive") {
        sonnerToast.error(title || "Error", {
          description,
        });
      } else {
        sonnerToast.success(title || "Success", {
          description,
        });
      }
    },
  };
}
